<template>
  <v-card class="px-6 py-2" color="transparent" elevation="0" outlined>
    <v-card-title class="my-0 py-0"><strong>CAR</strong></v-card-title>
    <v-card-text v-if="items.length > 0">
      <section v-for="(item, i) in items" :key="i" class="mb-4">
        <div class="d-block">
          <div
            class="
              d-flex
              justify-space-between
              align-content-start align-start
              mt-1
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <p class="mb-2 black--text" style="font-size: 14px" v-on="on">
                  <strong
                    >{{ item.car}}
                  </strong>
                </p>
              </template>
              <span>{{ item.car }}</span>
            </v-tooltip>
          </div>
          <ListComponent
            :item="item"
          />
        </div>
      </section>
    </v-card-text>
    <v-card-text v-else>
      {{ $t("general.fields.noDataAvailable") }}
    </v-card-text>
  </v-card>
</template>

<script>
  import ListComponent from "@/module/configuration/storage/components/integrations/BUNGE/csView/CAR/ListComponent"

  export default {
    name: "CARComponent",
    components: { ListComponent },
    props: {
      items: {
        type: Array,
        required: true,
        default: () => {
          return []
        },
      },
    },
  }
</script>

<style scoped>
  .v-chip.v-size--small,
  .v-chip.v-size--x-small {
    border-radius: 0.3em !important;
  }
  >>> .v-expansion-panel-content__wrap {
    padding: 0 0 16px !important;
  }
</style>
